import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'
import Layout from "@/views/layout/index.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/system',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/system/system',
    children: [
      {
        path: 'system',
        name: 'system',
        component: () => import('@/views/admin/index.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      }
    ]
  },

  {
    path: '/',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/homePage',
    children: [
      {
        path: 'homePage',
        name: 'homePage',
        component: () => import('@/views/homePage/homePage.vue'),
        meta: { title: '数据报表', icon: 'el-icon-s-home' }
      }
    ]
  },


  {
    path: '/supplier',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/supplier/supplier',
    children: [
      {
        path: 'supplier',
        name: 'supplier',
        component: () => import('@/views/supplier/supplier.vue'),
        meta: { title: '供应商', icon: 'el-icon-s-home' }
      }
    ]
  },

  {
    path: '/contract',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/contract/contract',
    children: [
      {
        path: 'contract',
        name: 'contract',
        component: () => import('@/views/contract/contract.vue'),
        meta: { title: '合同', icon: 'el-icon-s-home' }
      }
    ]
  },  {
    path: '/quotation',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/quotation/quotation',
    children: [
      {
        path: 'quotation',
        name: 'quotation',
        component: () => import('@/views/quotation/quotation.vue'),
        meta: { title: '报价单', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/config',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/config/config',
    children: [
      {
        path: 'config',
        name: 'config',
        component: () => import('@/views/config/config.vue'),
        meta: { title: '操作日志', icon: 'el-icon-s-home' }
      }
    ]
  },

  {
    path: '/customer',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/customer/customer',
    children: [
      {
        path: 'customer',
        name: 'customer',
        component: () => import('@/views/customer/customer.vue'),
        meta: { title: '客户', icon: 'el-icon-s-home' }
      }
    ]
  },

  {
    path: '/finance',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/finance/handle',
    children: [
      {
        path: 'handle',
        name: 'handle',
        component: () => import('@/views/finance/handle/handle.vue'),
        meta: { title: '应付', icon: 'el-icon-s-home' }
      },
      {
        path: 'receivable',
        name: 'receivable',
        component: () => import('@/views/finance/receivable/receivable.vue'),
        meta: { title: '应收', icon: 'el-icon-s-custom' }
      }
    ]
  },

  {
    path: '/configuration',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/configuration/warehouseType',
    children: [
      {
        path: 'warehouseType',
        name: 'warehouseType',
        component: () => import('@/views/configuration/warehouseType/warehouseType.vue'),
        meta: { title: '仓库类型', icon: 'el-icon-s-custom' }
      },

      {
        path: 'commission',
        name: 'commission',
        component: () => import('@/views/configuration/commission/commission.vue'),
        meta: { title: '提成规则', icon: 'el-icon-menu' }
      },
      {
        path: 'processBag',
        name: 'processBag',
        component: () => import('@/views/configuration/processBag/processBag.vue'),
        meta: { title: '袋型', icon: 'el-icon-menu' }
      },
      {
        path: 'processKong',
        name: 'processKong',
        component: () => import('@/views/configuration/processKong/processKong.vue'),
        meta: { title: '打孔', icon: 'el-icon-menu' }
      },

      {
        path: 'payment',
        name: 'payment',
        component: () => import('@/views/configuration/payment/payment.vue'),
        meta: { title: '付款配置', icon: 'el-icon-s-custom' }
      }
    ]
  },
  {
    path: '/processCost',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/processCost/processCost',
    children: [
      {
        path: 'processCost',
        name: 'processCost',
        component: () => import('@/views/processCost/processCost/processCost.vue'),
        meta: { title: '加工费', icon: 'el-icon-s-home' }
      },
      {
        path: 'processingPlant',
        name: 'processingPlant',
        component: () => import('@/views/processCost/processingPlant/processingPlant.vue'),
        meta: { title: '加工厂', icon: 'el-icon-s-home' }
      },
      {
        path: 'processOrder',
        name: 'processOrder',
        component: () => import('@/views/processCost/processOrder/processOrder.vue'),
        meta: { title: '加工费单', icon: 'el-icon-s-custom' }
      }
    ]
  },

  {
    path: '/customization',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/customization/customization',
    children: [
      {
        path: 'customization',
        name: 'customization',
        component: () => import('@/views/customization/customization.vue'),
        meta: { title: '定制单', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/sales',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/sales/sales',
    children: [
      {
        path: 'sales',
        name: 'sales',
        component: () => import('@/views/sales/sales.vue'),
        meta: { title: '销售单', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/fetchGoods',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/fetchGoods/fetchGoods',
    children: [
      {
        path: 'fetchGoods',
        name: 'fetchGoods',
        component: () => import('@/views/fetchGoods/fetchGoods.vue'),
        meta: { title: '分批次提货管理', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/invoice',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/invoice/invoice',
    children: [
      {
        path: 'invoice',
        name: 'invoice',
        component: () => import('@/views/invoice/invoice.vue'),
        meta: { title: '发票汇总管理', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/product',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/product/product',
    children: [
      {
        path: 'product',
        name: 'product',
        component: () => import('@/views/product/product.vue'),
        meta: { title: '产品', icon: 'el-icon-s-home' }
      }
    ]
  },

  {
    path: '/salesman',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/salesman/salesman',
    children: [
      {
        path: 'salesman',
        name: 'salesman',
        component: () => import('@/views/salesman/salesman.vue'),
        meta: { title: '业务员统计', icon: 'el-icon-s-home' }
      }
    ]
  },


  {
    path: '/employee',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/employee',
    meta: { title: '员工管理', icon: 'el-icon-s-tools' },
    children: [
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('@/views/admin/index.vue'),
        meta: { title: '员工列表', icon: 'el-icon-user' }
      },
      {
        path: 'visitor',
        name: 'Visitor',
        component: () => import('@/views/visitor/visitor.vue'),
        meta: { title: '访客管理', icon: 'el-icon-s-custom' }
      }
    ]
  },
  {
    path: '/FinishedProductsWarehouse',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/FinishedProductsWarehouse/FinishedProductsWarehouse',
    meta: { title: '成品库', icon: 'el-icon-s-tools' },
    children: [
      {
        path: 'FinishedProductsWarehouse',
        name: 'FinishedProductsWarehouse',
        component: () => import('@/views/FinishedProductsWarehouse/FinishedProductsWarehouse/FinishedProductsWarehouse.vue'),
        meta: { title: '成品库', icon: 'el-icon-user' }
      },
      {
        path: 'FinishedProductsIn',
        name: 'FinishedProductsIn',
        component: () => import('@/views/FinishedProductsWarehouse/FinishedProductsIn/FinishedProductsIn.vue'),
        meta: { title: '入库', icon: 'el-icon-user' }
      },
      {
        path: 'FinishedProductsOut',
        name: 'FinishedProductsOut',
        component: () => import('@/views/FinishedProductsWarehouse/FinishedProductsOut/FinishedProductsOut.vue'),
        meta: { title: '出库', icon: 'el-icon-s-custom' }
      }
    ]
  },
  {
    path: '/warehouse',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/warehouse/warehouse',
    meta: { title: '仓库', icon: 'el-icon-s-tools' },
    children: [
      {
        path: 'warehouse',
        name: 'warehouse',
        component: () => import('@/views/warehouse/warehouse/warehouse.vue'),
        meta: { title: '仓库', icon: 'el-icon-user' }
      },
      {
        path: 'warehouseIn',
        name: 'warehouseIn',
        component: () => import('@/views/warehouse/warehouseIn/warehouseIn.vue'),
        meta: { title: '仓库入库记录', icon: 'el-icon-user' }
      },
      {
        path: 'warehouseOut',
        name: 'warehouseOut',
        component: () => import('@/views/warehouse/warehouseOut/warehouseOut.vue'),
        meta: { title: '仓库出库记录', icon: 'el-icon-user' }
      },

    ]
  },
  {
    path: '/manifest',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/manifest',
    meta: { title: '货单管理', icon: 'el-icon-s-tools' },
    children: [
      {
        path: 'enterManifest',
        name: 'enterManifest',
        component: () => import('@/views/manifest/enterManifest/enterManifest.vue'),
        meta: { title: '进货单', icon: 'el-icon-user' }
      },
      {
        path: 'outManifest',
        name: 'outManifest',
        component: () => import('@/views/manifest/outManifest/outManifest.vue'),
        meta: { title: '出货单', icon: 'el-icon-s-custom' }
      }
    ]
  },

  {
    path: '/system',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/system/admin',
    meta: { title: '系统管理', icon: 'el-icon-s-tools' },
    children: [
      {
        path: 'role',
        name: 'Role',
        component: () => import('@/views/role/index.vue'),
        meta: { title: '角色管理', icon: 'el-icon-s-custom' }
      },
      {
        path: 'menu',
        name: 'Menu',
        component: () => import('@/views/menu/index.vue'),
        meta: { title: '菜单管理', icon: 'el-icon-menu' }
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = getToken()
  if (to.path === '/login') {
    next()
  } else {
    if (!token) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router
